<template>
	<ext-dialog
		v-model="value"
		:title="$t('filter')"
		:primaryButtonText="$t('ok')"
		@primaryButtonAction="okButtonAction"
		:secondaryButtonText="$t('clear')"
		@secondaryButtonAction="clearButtonAction"
		@closed="cancelButtonAction"
	>
		<template #body>
			<v-text-field v-model="panelData.text" :label="`${$t('product')} / ${$t('code')}`" clearable />
			<v-text-field v-model="panelData.lotNo" :label="$t('lot_no')" clearable />
			<v-select
				v-model="panelData.warehouse"
				:items="warehouseOptions"
				item-value="_id"
				item-text="name"
				:label="$t('warehouse')"
				clearable
				outlined
				append-icon="icon-angle-down"
				:menu-props="{ offsetY: true }"
			/>
		</template>
	</ext-dialog>
</template>

<script>
import ExtDialog from "../../../partials/dialogs/ExtDialog.vue";
import remote from "../../../../data/remote";
import { mapGetters } from "vuex";

export default {
	name: "StockFilterDialog",
	components: { ExtDialog },
	props: {
		value: Boolean,
		data: Object,
		companyId: String,
	},
	data() {
		return {
			panelData: {
				text: null,
				lotNo: null,
				warehouse: null,
			},
			warehouseOptions: [],
		};
	},
	computed: {
		...mapGetters(["company"]),
	},
	watch: {
		value(open) {
			if (open) {
				this.panelData.text = this.data.text ?? null;
				this.panelData.lotNo = this.data.lotNo ?? null;
				this.panelData.warehouse = this.data.warehouse ?? null;
				if (!this.warehouseOptions.length) this.loadWarehouses();
			}
		},
	},
	methods: {
		okButtonAction() {
			this.$emit("done", {
				text: this.panelData.text || undefined,
				lotNo: this.panelData.lotNo || undefined,
				warehouse: this.panelData.warehouse || undefined,
			});
		},
		clearButtonAction() {
			this.$emit("done", { text: undefined, lotNo: undefined, warehouse: undefined });
		},
		cancelButtonAction() {
			this.$emit("input", false);
		},
		loadWarehouses() {
			const cid = this.companyId || this.company?.id;
			if (!cid) return;
			remote.warehouses.filter(cid, {
				onSuccess: (list) => (this.warehouseOptions = list),
			});
		},
	},
};
</script>
